var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    enableBackground: "new 0 0 68 68",
    xmlSpace: "preserve",
    viewBox: "2 5 64.04 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.2,55.7h-1.3V22.4H65c0.3,0,0.6-0.1,0.8-0.4s0.3-0.5,0.2-0.8L62.9,5.8c-0.1-0.5-0.5-0.8-1-0.8H6.1c-0.5,0-0.9,0.3-1,0.8   L2,21.2C2,21.4,2,21.8,2.2,22s0.5,0.4,0.8,0.4h2.1v33.4H3.8c-1,0-1.8,0.8-1.8,1.8v3.6c0,1,0.8,1.8,1.8,1.8h60.3   c1,0,1.8-0.8,1.8-1.8v-3.6C66,56.6,65.2,55.7,64.2,55.7z M6.9,7h54.1l2.7,13.4c-18.9,0-40.3,0-59.6,0L6.9,7z M7.1,22.4h53.8v33.4   H28.8V32.2c0-0.6-0.4-1-1-1H11.1c-0.6,0-1,0.4-1,1v23.5h-3V22.4z M26.8,55.7H12.1V33.2h14.7V55.7z M64,61H4v-3.3c22.2,0,46,0,60,0   V61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9,52.7h22c0.6,0,1-0.4,1-1V32.2c0-0.6-0.4-1-1-1c-7.5,0-13.8,0-22,0c-0.6,0-1,0.4-1,1v19.5   C33.9,52.3,34.3,52.7,34.9,52.7z M35.9,43h9v7.8h-9V43z M46.9,50.7V43h9v7.8H46.9z M55.9,41h-9v-7.7h9V41z M44.9,33.2V41h-9v-7.7   H44.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHouse);
export default __webpack_public_path__ + "static/media/icon-house.40d24f1df6471f0f42fa371498511d31.svg";
export { ForwardRef as ReactComponent };